(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 2350:
/***/ (function() {



/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(85629);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52258:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
/* provided dependency */ var process = __webpack_require__(34155);
__webpack_require__(2350);
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/ function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var isProd = typeof process !== "undefined" && process.env && "production" === "production";
var isString = function isString(o) {
    return Object.prototype.toString.call(o) === "[object String]";
};
var StyleSheet = /*#__PURE__*/ function() {
    var StyleSheet = function StyleSheet(param) {
        var ref = param === void 0 ? {} : param, _name = ref.name, name = _name === void 0 ? "stylesheet" : _name, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
        invariant$1(isString(name), "`name` must be a string");
        this._name = name;
        this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
        invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
        this._optimizeForSpeed = optimizeForSpeed;
        this._serverSheet = undefined;
        this._tags = [];
        this._injected = false;
        this._rulesCount = 0;
        var node =  true && document.querySelector('meta[property="csp-nonce"]');
        this._nonce = node ? node.getAttribute("content") : null;
    };
    var _proto = StyleSheet.prototype;
    _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
        invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
        invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
        this.flush();
        this._optimizeForSpeed = bool;
        this.inject();
    };
    _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
        return this._optimizeForSpeed;
    };
    _proto.inject = function inject() {
        var _this = this;
        invariant$1(!this._injected, "sheet already injected");
        this._injected = true;
        if ( true && this._optimizeForSpeed) {
            this._tags[0] = this.makeStyleTag(this._name);
            this._optimizeForSpeed = "insertRule" in this.getSheet();
            if (!this._optimizeForSpeed) {
                if (!isProd) {
                    console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
                }
                this.flush();
                this._injected = true;
            }
            return;
        }
        this._serverSheet = {
            cssRules: [],
            insertRule: function insertRule(rule, index) {
                if (typeof index === "number") {
                    _this._serverSheet.cssRules[index] = {
                        cssText: rule
                    };
                } else {
                    _this._serverSheet.cssRules.push({
                        cssText: rule
                    });
                }
                return index;
            },
            deleteRule: function deleteRule(index) {
                _this._serverSheet.cssRules[index] = null;
            }
        };
    };
    _proto.getSheetForTag = function getSheetForTag(tag) {
        if (tag.sheet) {
            return tag.sheet;
        }
        // this weirdness brought to you by firefox
        for(var i = 0; i < document.styleSheets.length; i++){
            if (document.styleSheets[i].ownerNode === tag) {
                return document.styleSheets[i];
            }
        }
    };
    _proto.getSheet = function getSheet() {
        return this.getSheetForTag(this._tags[this._tags.length - 1]);
    };
    _proto.insertRule = function insertRule(rule, index) {
        invariant$1(isString(rule), "`insertRule` accepts only strings");
        if (false) {}
        if (this._optimizeForSpeed) {
            var sheet = this.getSheet();
            if (typeof index !== "number") {
                index = sheet.cssRules.length;
            }
            // this weirdness for perf, and chrome's weird bug
            // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                return -1;
            }
        } else {
            var insertionPoint = this._tags[index];
            this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
        }
        return this._rulesCount++;
    };
    _proto.replaceRule = function replaceRule(index, rule) {
        if (this._optimizeForSpeed || "object" === "undefined") {
            var sheet =  true ? this.getSheet() : 0;
            if (!rule.trim()) {
                rule = this._deletedRulePlaceholder;
            }
            if (!sheet.cssRules[index]) {
                // @TBD Should we throw an error?
                return index;
            }
            sheet.deleteRule(index);
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                // In order to preserve the indices we insert a deleteRulePlaceholder
                sheet.insertRule(this._deletedRulePlaceholder, index);
            }
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "old rule at index `" + index + "` not found");
            tag.textContent = rule;
        }
        return index;
    };
    _proto.deleteRule = function deleteRule(index) {
        if (false) {}
        if (this._optimizeForSpeed) {
            this.replaceRule(index, "");
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "rule at index `" + index + "` not found");
            tag.parentNode.removeChild(tag);
            this._tags[index] = null;
        }
    };
    _proto.flush = function flush() {
        this._injected = false;
        this._rulesCount = 0;
        if (true) {
            this._tags.forEach(function(tag) {
                return tag && tag.parentNode.removeChild(tag);
            });
            this._tags = [];
        } else {}
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        if (false) {}
        return this._tags.reduce(function(rules, tag) {
            if (tag) {
                rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function(rule) {
                    return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
                }));
            } else {
                rules.push(null);
            }
            return rules;
        }, []);
    };
    _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
        if (cssString) {
            invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
        }
        var tag = document.createElement("style");
        if (this._nonce) tag.setAttribute("nonce", this._nonce);
        tag.type = "text/css";
        tag.setAttribute("data-" + name, "");
        if (cssString) {
            tag.appendChild(document.createTextNode(cssString));
        }
        var head = document.head || document.getElementsByTagName("head")[0];
        if (relativeToTag) {
            head.insertBefore(tag, relativeToTag);
        } else {
            head.appendChild(tag);
        }
        return tag;
    };
    _createClass(StyleSheet, [
        {
            key: "length",
            get: function get() {
                return this._rulesCount;
            }
        }
    ]);
    return StyleSheet;
}();
function invariant$1(condition, message) {
    if (!condition) {
        throw new Error("StyleSheet: " + message + ".");
    }
}
function hash(str) {
    var _$hash = 5381, i = str.length;
    while(i){
        _$hash = _$hash * 33 ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return _$hash >>> 0;
}
var stringHash = hash;
var sanitize = function sanitize(rule) {
    return rule.replace(/\/style/gi, "\\/style");
};
var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */ function computeId(baseId, props) {
    if (!props) {
        return "jsx-" + baseId;
    }
    var propsToString = String(props);
    var key = baseId + propsToString;
    if (!cache[key]) {
        cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
    }
    return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */ function computeSelector(id, css) {
    var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g;
    // Sanitize SSR-ed CSS.
    // Client side code doesn't need to be sanitized since we use
    // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
    if (false) {}
    var idcss = id + css;
    if (!cache[idcss]) {
        cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
    }
    return cache[idcss];
}
function mapRulesToStyle(cssRules, options) {
    if (options === void 0) options = {};
    return cssRules.map(function(args) {
        var id = args[0];
        var css = args[1];
        return /*#__PURE__*/ React__default["default"].createElement("style", {
            id: "__" + id,
            // Avoid warnings upon render with a key
            key: "__" + id,
            nonce: options.nonce ? options.nonce : undefined,
            dangerouslySetInnerHTML: {
                __html: css
            }
        });
    });
}
var StyleSheetRegistry = /*#__PURE__*/ function() {
    var StyleSheetRegistry = function StyleSheetRegistry(param) {
        var ref = param === void 0 ? {} : param, _styleSheet = ref.styleSheet, styleSheet = _styleSheet === void 0 ? null : _styleSheet, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
        this._sheet = styleSheet || new StyleSheet({
            name: "styled-jsx",
            optimizeForSpeed: optimizeForSpeed
        });
        this._sheet.inject();
        if (styleSheet && typeof optimizeForSpeed === "boolean") {
            this._sheet.setOptimizeForSpeed(optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    var _proto = StyleSheetRegistry.prototype;
    _proto.add = function add(props) {
        var _this = this;
        if (undefined === this._optimizeForSpeed) {
            this._optimizeForSpeed = Array.isArray(props.children);
            this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        if ( true && !this._fromServer) {
            this._fromServer = this.selectFromServer();
            this._instancesCounts = Object.keys(this._fromServer).reduce(function(acc, tagName) {
                acc[tagName] = 0;
                return acc;
            }, {});
        }
        var ref = this.getIdAndRules(props), styleId = ref.styleId, rules = ref.rules;
        // Deduping: just increase the instances count.
        if (styleId in this._instancesCounts) {
            this._instancesCounts[styleId] += 1;
            return;
        }
        var indices = rules.map(function(rule) {
            return _this._sheet.insertRule(rule);
        }) // Filter out invalid rules
        .filter(function(index) {
            return index !== -1;
        });
        this._indices[styleId] = indices;
        this._instancesCounts[styleId] = 1;
    };
    _proto.remove = function remove(props) {
        var _this = this;
        var styleId = this.getIdAndRules(props).styleId;
        invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
        this._instancesCounts[styleId] -= 1;
        if (this._instancesCounts[styleId] < 1) {
            var tagFromServer = this._fromServer && this._fromServer[styleId];
            if (tagFromServer) {
                tagFromServer.parentNode.removeChild(tagFromServer);
                delete this._fromServer[styleId];
            } else {
                this._indices[styleId].forEach(function(index) {
                    return _this._sheet.deleteRule(index);
                });
                delete this._indices[styleId];
            }
            delete this._instancesCounts[styleId];
        }
    };
    _proto.update = function update(props, nextProps) {
        this.add(nextProps);
        this.remove(props);
    };
    _proto.flush = function flush() {
        this._sheet.flush();
        this._sheet.inject();
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function(styleId) {
            return [
                styleId,
                _this._fromServer[styleId]
            ];
        }) : [];
        var cssRules = this._sheet.cssRules();
        return fromServer.concat(Object.keys(this._indices).map(function(styleId) {
            return [
                styleId,
                _this._indices[styleId].map(function(index) {
                    return cssRules[index].cssText;
                }).join(_this._optimizeForSpeed ? "" : "\n")
            ];
        }) // filter out empty rules
        .filter(function(rule) {
            return Boolean(rule[1]);
        }));
    };
    _proto.styles = function styles(options) {
        return mapRulesToStyle(this.cssRules(), options);
    };
    _proto.getIdAndRules = function getIdAndRules(props) {
        var css = props.children, dynamic = props.dynamic, id = props.id;
        if (dynamic) {
            var styleId = computeId(id, dynamic);
            return {
                styleId: styleId,
                rules: Array.isArray(css) ? css.map(function(rule) {
                    return computeSelector(styleId, rule);
                }) : [
                    computeSelector(styleId, css)
                ]
            };
        }
        return {
            styleId: computeId(id),
            rules: Array.isArray(css) ? css : [
                css
            ]
        };
    };
    /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */ _proto.selectFromServer = function selectFromServer() {
        var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
        return elements.reduce(function(acc, element) {
            var id = element.id.slice(2);
            acc[id] = element;
            return acc;
        }, {});
    };
    return StyleSheetRegistry;
}();
function invariant(condition, message) {
    if (!condition) {
        throw new Error("StyleSheetRegistry: " + message + ".");
    }
}
var StyleSheetContext = /*#__PURE__*/ React.createContext(null);
StyleSheetContext.displayName = "StyleSheetContext";
function createStyleRegistry() {
    return new StyleSheetRegistry();
}
function StyleRegistry(param) {
    var configuredRegistry = param.registry, children = param.children;
    var rootRegistry = React.useContext(StyleSheetContext);
    var ref = React.useState(function() {
        return rootRegistry || configuredRegistry || createStyleRegistry();
    }), registry = ref[0];
    return /*#__PURE__*/ React__default["default"].createElement(StyleSheetContext.Provider, {
        value: registry
    }, children);
}
function useStyleRegistry() {
    return React.useContext(StyleSheetContext);
}
// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
var defaultRegistry =  true ? createStyleRegistry() : 0;
function JSXStyle(props) {
    var registry = defaultRegistry ? defaultRegistry : useStyleRegistry();
    // If `registry` does not exist, we do nothing here.
    if (!registry) {
        return null;
    }
    if (false) {}
    useInsertionEffect(function() {
        registry.add(props);
        return function() {
            registry.remove(props);
        };
    // props.children can be string[], will be striped since id is identical
    }, [
        props.id,
        String(props.dynamic)
    ]);
    return null;
}
JSXStyle.dynamic = function(info) {
    return info.map(function(tagInfo) {
        var baseId = tagInfo[0];
        var props = tagInfo[1];
        return computeId(baseId, props);
    }).join(" ");
};
__webpack_unused_export__ = StyleRegistry;
__webpack_unused_export__ = createStyleRegistry;
exports.style = JSXStyle;
__webpack_unused_export__ = useStyleRegistry;


/***/ }),

/***/ 30891:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(52258).style;


/***/ }),

/***/ 85629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(30891);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(56917);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(64978);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(92072);
;// CONCATENATED MODULE: ./src/components/PageSection/svg/CurvedSvg.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 20px;\n  clip-path: url(",
        ");\n\n  background: ",
        ";\n\n  & svg {\n    display: block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  transform: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  transform: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var sharedStyles = function(theme, clipPath, clipFill) {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), clipPath, function() {
        if (theme.isDark) {
            return (clipFill === null || clipFill === void 0 ? void 0 : clipFill.dark) || (clipFill === null || clipFill === void 0 ? void 0 : clipFill.light) || theme.colors.background;
        }
        return (clipFill === null || clipFill === void 0 ? void 0 : clipFill.light) || theme.colors.background;
    });
};
var ConcaveContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-f0d6319c-0"
})(_templateObject1(), function(param) {
    var theme = param.theme, clipPath = param.clipPath, clipFill = param.clipFill;
    return sharedStyles(theme, clipPath, clipFill);
}, function(param) {
    var clipPath = param.clipPath;
    return clipPath === "#bottomConcaveCurve" ? "translate(0, -13px)" : "translate(0, 1px)";
});
var ConvexContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-f0d6319c-1"
})(_templateObject2(), function(param) {
    var theme = param.theme, clipPath = param.clipPath, clipFill = param.clipFill;
    return sharedStyles(theme, clipPath, clipFill);
}, function(param) {
    var clipPath = param.clipPath;
    return clipPath === "#bottomConvexCurve" ? "translate(0, -13px)" : "translate(0, -1px)";
});
var ConvexTop = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConvexContainer, {
        clipFill: clipFill,
        clipPath: "#topConvexCurve",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "topConvexCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M 0,1 L 0,0 L 1,0 L 1,1 C 0.75 0, .25 0, 0 1 Z"
                    })
                })
            })
        })
    });
};
var ConvexBottom = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConvexContainer, {
        clipFill: clipFill,
        clipPath: "#bottomConvexCurve",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "bottomConvexCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M 0,0 L 0,1 L 1,1 L 1,0 C .75 1, .25 1, 0 0 Z"
                    })
                })
            })
        })
    });
};
var ConcaveTop = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConcaveContainer, {
        clipFill: clipFill,
        clipPath: "#topConcaveCurve",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "topConcaveCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M 0,0 L 0,1 L 1,1 L 1,0 C .75 1, .25 1, 0 0 Z"
                    })
                })
            })
        })
    });
};
var ConcaveBottom = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConcaveContainer, {
        clipFill: clipFill,
        clipPath: "#bottomConcaveCurve",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "bottomConcaveCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M 0,1 L 0,0 L 1,0 L 1,1 C .75 0.1, .25 0.1, 0 1 Z"
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/PageSection/CurvedDivider.tsx

function CurvedDivider_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  z-index: ",
        ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n"
    ]);
    CurvedDivider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CurvedDivider_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"
    ]);
    CurvedDivider_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82a6e052-0"
})(CurvedDivider_templateObject(), function(param) {
    var theme = param.theme, dividerFill = param.dividerFill;
    if (theme.isDark) {
        return (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.dark) || (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.light) || "none";
    }
    return (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.light) || (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.dark) || "none";
}, function(param) {
    var index = param.index;
    return index;
});
var ComponentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82a6e052-1"
})(CurvedDivider_templateObject1(), function(param) {
    var index = param.index;
    return index + 1;
});
var CurvedDivider = function(param) {
    var index = param.index, dividerPosition = param.dividerPosition, dividerComponent = param.dividerComponent, concave = param.concave, clipFill = param.clipFill, dividerFill = param.dividerFill;
    var showConvexTop = dividerPosition === "top" && !concave;
    var showConvexBottom = dividerPosition === "bottom" && !concave;
    var showConcaveTop = dividerPosition === "top" && concave;
    var showConcaveBottom = dividerPosition === "bottom" && concave;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        index: index,
        dividerFill: dividerFill,
        children: [
            dividerComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper, {
                index: index,
                children: dividerComponent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showConcaveTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConcaveTop, {
                        clipFill: clipFill
                    }),
                    showConcaveBottom && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConcaveBottom, {
                        clipFill: clipFill
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showConvexTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConvexTop, {
                        clipFill: clipFill
                    }),
                    showConvexBottom && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConvexBottom, {
                        clipFill: clipFill
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PageSection_CurvedDivider = (CurvedDivider);

;// CONCATENATED MODULE: ./src/components/PageSection/index.tsx




function PageSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-direction: column;\n  align-items: center;\n  z-index: ",
        ";\n  padding: ",
        ";\n"
    ]);
    PageSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PageSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: auto;\n  padding-top: 16px;\n  padding-bottom: 16px;\n\n  ",
        " {\n    padding-top: 32px;\n    padding-bottom: 32px;\n  }\n\n  ",
        " {\n    padding-top: 48px;\n    padding-bottom: 48px;\n  }\n"
    ]);
    PageSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var BackgroundColor = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    className: "page-bg"
}).withConfig({
    componentId: "sc-308e1ef1-0"
})(PageSection_templateObject(), function(param) {
    var index = param.index;
    return index - 1;
}, function(param) {
    var padding = param.padding;
    return padding;
});
var ChildrenWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-308e1ef1-1"
})(PageSection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var PageSection = function(_param) {
    var children = _param.children, svgFill = _param.svgFill, _param_index = _param.index, index = _param_index === void 0 ? 1 : _param_index, dividerComponent = _param.dividerComponent, _param_dividerPosition = _param.dividerPosition, dividerPosition = _param_dividerPosition === void 0 ? "bottom" : _param_dividerPosition, _param_hasCurvedDivider = _param.hasCurvedDivider, hasCurvedDivider = _param_hasCurvedDivider === void 0 ? true : _param_hasCurvedDivider, _param_concaveDivider = _param.concaveDivider, concaveDivider = _param_concaveDivider === void 0 ? false : _param_concaveDivider, clipFill = _param.clipFill, dividerFill = _param.dividerFill, containerProps = _param.containerProps, innerProps = _param.innerProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "svgFill",
        "index",
        "dividerComponent",
        "dividerPosition",
        "hasCurvedDivider",
        "concaveDivider",
        "clipFill",
        "dividerFill",
        "containerProps",
        "innerProps"
    ]);
    var padding = (0,react.useMemo)(function() {
        // No curved divider
        if (!hasCurvedDivider) {
            return "48px 0";
        }
        // Bottom curved divider
        // Less bottom padding, as the divider is present there
        if (dividerPosition === "bottom") {
            return "48px 0 14px";
        }
        // Top curved divider
        // Less top padding, as the divider is present there
        if (dividerPosition === "top") {
            return "14px 0 48px";
        }
        return "48px 0";
    }, [
        dividerPosition,
        hasCurvedDivider
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, containerProps), {
        children: [
            hasCurvedDivider && dividerPosition === "top" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection_CurvedDivider, {
                svgFill: svgFill,
                index: index,
                concave: concaveDivider,
                dividerPosition: dividerPosition,
                dividerComponent: dividerComponent,
                clipFill: clipFill,
                dividerFill: dividerFill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundColor, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                index: index,
                padding: padding
            }, props), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, innerProps), {
                    children: children
                }))
            })),
            hasCurvedDivider && dividerPosition === "bottom" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection_CurvedDivider, {
                svgFill: svgFill,
                index: index,
                concave: concaveDivider,
                dividerPosition: dividerPosition,
                dividerComponent: dividerComponent,
                clipFill: clipFill,
                dividerFill: dividerFill
            })
        ]
    }));
};
/* harmony default export */ var components_PageSection = (PageSection);

// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(45070);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(83435);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(17257);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(31136);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(61328);
// EXTERNAL MODULE: ./src/components/NextLink.tsx
var NextLink = __webpack_require__(64030);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 5 modules
var localization_src = __webpack_require__(90915);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./public/images/home/lunar-bunny/astronaut-bunny.png
var astronaut_bunny = __webpack_require__(57728);
;// CONCATENATED MODULE: ./src/views/Home/components/CompositeImage.tsx

function CompositeImage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translate(0,  0px);\n  }\n  50% {\n    transform: translate(",
        ", ",
        ");\n  }\n  to {\n    transform: translate(0, 0px);\n  }\n"
    ]);
    CompositeImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompositeImage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  max-height: ",
        ";\n\n  & :nth-child(2) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 1s;\n  }\n\n  & :nth-child(3) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 0.66s;\n  }\n\n  & :nth-child(4) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 0.33s;\n  }\n\n  & :nth-child(5) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 0s;\n  }\n"
    ]);
    CompositeImage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompositeImage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: ",
        ";\n  visibility: hidden;\n"
    ]);
    CompositeImage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  img {\n    max-height: 100%;\n    width: auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var floatingAnim = function(x, y) {
    return (0,styled_components_browser_esm/* keyframes */.F4)(CompositeImage_templateObject(), x, y);
};
var CompositeImage_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-dd92527b-0"
})(CompositeImage_templateObject1(), function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight;
}, floatingAnim("3px", "15px"), floatingAnim("5px", "10px"), floatingAnim("6px", "5px"), floatingAnim("4px", "12px"));
var DummyImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-dd92527b-1"
})(CompositeImage_templateObject2(), function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight;
});
var ImageWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-dd92527b-2"
})(_templateObject3());
var Resolution;
(function(Resolution) {
    Resolution["MD"] = "1.5x";
    Resolution["LG"] = "2x";
})(Resolution || (Resolution = {}));
var getImageUrl = function(base, imageSrc, resolution) {
    var extension = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".png";
    return "".concat(base).concat(imageSrc).concat(resolution ? "@".concat(resolution).concat(extension) : extension);
};
var getSrcSet = function(base, imageSrc) {
    var extension = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".png";
    return "".concat(getImageUrl(base, imageSrc, undefined, extension), " 512w,\n  ").concat(getImageUrl(base, imageSrc, Resolution.MD, extension), " 768w,\n  ").concat(getImageUrl(base, imageSrc, Resolution.LG, extension), " 1024w,");
};
var CompositeImage = function(param) {
    var path = param.path, attributes = param.attributes, _param_maxHeight = param.maxHeight, maxHeight = _param_maxHeight === void 0 ? "512px" : _param_maxHeight;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompositeImage_Wrapper, {
        maxHeight: maxHeight,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DummyImg, {
                srcSet: getSrcSet(path, attributes[0].src, ".webp"),
                maxHeight: maxHeight,
                loading: "lazy",
                decoding: "async",
                onError: function(e) {
                    var fallbackSrcSet = getSrcSet(path, attributes[0].src);
                    if (e.currentTarget.srcset !== "" && e.currentTarget.srcset !== fallbackSrcSet) {
                        // eslint-disable-next-line no-param-reassign
                        e.currentTarget.srcset = fallbackSrcSet;
                    } else {
                        var fallbackSrc = getImageUrl(path, attributes[0].src);
                        if (e.currentTarget.srcset !== "" && !e.currentTarget.src.endsWith(fallbackSrc)) {
                            // eslint-disable-next-line no-param-reassign
                            e.currentTarget.srcset = "";
                            // eslint-disable-next-line no-param-reassign
                            e.currentTarget.src = fallbackSrc;
                        }
                    }
                }
            }),
            attributes.map(function(image) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        srcSet: getSrcSet(path, image.src, ".webp"),
                        alt: image.alt,
                        onError: function(e) {
                            var fallbackSrcSet = getSrcSet(path, image.src);
                            if (e.currentTarget.srcset !== "" && e.currentTarget.srcset !== fallbackSrcSet) {
                                // eslint-disable-next-line no-param-reassign
                                e.currentTarget.srcset = fallbackSrcSet;
                            } else {
                                var fallbackSrc = getImageUrl(path, image.src);
                                if (e.currentTarget.srcset !== "" && !e.currentTarget.src.endsWith(fallbackSrc)) {
                                    // eslint-disable-next-line no-param-reassign
                                    e.currentTarget.srcset = "";
                                    // eslint-disable-next-line no-param-reassign
                                    e.currentTarget.src = fallbackSrc;
                                }
                            }
                        }
                    })
                }, image.src);
            })
        ]
    });
};
/* harmony default export */ var components_CompositeImage = (CompositeImage);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(75228);
;// CONCATENATED MODULE: ./src/views/Home/components/SlideSvg.tsx




var SlideSvgLight = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 1660 339"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M804 167.023C520.5 167.023 267.5 290.522 0 304.5V339H1660V0.5C1358.83 0.5 1104 167.023 804 167.023Z",
                fill: "url(#paint0_linear_light)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_light",
                    x1: "830",
                    y1: "84",
                    x2: "830",
                    y2: "339",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "white",
                            stopOpacity: "0.48"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.566389",
                            stopColor: "white",
                            stopOpacity: "0.35"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: "white"
                        })
                    ]
                })
            })
        ]
    }));
};
var SlideSvgDark = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 1660 339"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M804 166.523C520.5 166.523 267.5 290.022 0 304V338.5H1660V0C1358.83 0 1104 166.523 804 166.523Z",
                fill: "url(#paint0_linear_dark)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_dark",
                    x1: "830",
                    y1: "83.5",
                    x2: "830",
                    y2: "338.5",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#08060B",
                            stopOpacity: "0.2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.545554",
                            stopColor: "#08060B",
                            stopOpacity: "0.5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: "#08060B"
                        })
                    ]
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/views/Home/components/Hero.tsx


function Hero_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translate(0,  0px);\n  }\n  50% {\n    transform: translate(-5px, -5px);\n  }\n  to {\n    transform: translate(0, 0px);\n  }\n"
    ]);
    Hero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Hero_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    opacity: 0.9;\n  }\n  50% {\n    opacity: 0.1;\n  }\n  to {\n    opacity: 0.9;\n  }\n"
    ]);
    Hero_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Hero_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: -1;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  bottom: 0px;\n  left: 0px;\n"
    ]);
    Hero_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Hero_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n  bottom: -3px;\n"
    ]);
    Hero_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  animation: ",
        " 3.5s ease-in-out infinite;\n  will-change: transform;\n  > span {\n    overflow: visible !important; // make sure the next-image pre-build blur image not be cropped\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  & :nth-child(2) {\n    animation: ",
        " 2s ease-in-out infinite;\n    animation-delay: 1s;\n  }\n\n  & :nth-child(3) {\n    animation: ",
        " 5s ease-in-out infinite;\n    animation-delay: 0.66s;\n  }\n\n  & :nth-child(4) {\n    animation: ",
        " 2.5s ease-in-out infinite;\n    animation-delay: 0.33s;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}












var flyingAnim = function() {
    return (0,styled_components_browser_esm/* keyframes */.F4)(Hero_templateObject());
};
var fading = function() {
    return (0,styled_components_browser_esm/* keyframes */.F4)(Hero_templateObject1());
};
var BgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-296406d4-0"
})(Hero_templateObject2());
var InnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-296406d4-1"
})(Hero_templateObject3());
var BunnyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-296406d4-2"
})(_templateObject4(), flyingAnim);
var StarsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-296406d4-3"
})(_templateObject5(), fading, fading, fading);
var starsImage = {
    path: "/images/home/lunar-bunny/",
    attributes: [
        {
            src: "star-l",
            alt: "3D Star"
        },
        {
            src: "star-r",
            alt: "3D Star"
        },
        {
            src: "star-top-r",
            alt: "3D Star"
        }
    ]
};
var Hero = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var account = (0,src/* useWeb3React */.Ge)().account;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (0,jsx_runtime.jsx)((style_default()), {
                id: "17b87fe7f0af5ff",
                children: '.slide-svg-dark{display:none}.slide-svg-light{display:block}[data-theme="dark"] .slide-svg-dark{display:block}[data-theme="dark"] .slide-svg-light{display:none}'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BgWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideSvgDark, {
                            className: "slide-svg-dark",
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideSvgLight, {
                            className: "slide-svg-light",
                            width: "100%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                position: "relative",
                flexDirection: [
                    "column-reverse",
                    null,
                    null,
                    "row"
                ],
                alignItems: [
                    "flex-end",
                    null,
                    null,
                    "center"
                ],
                justifyContent: "center",
                mt: [
                    account ? "280px" : "50px",
                    null,
                    0
                ],
                id: "homepage-hero",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flex: "1",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                scale: "xxl",
                                color: "secondary",
                                mb: "24px",
                                children: t("Let's F*#@$* Game")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                scale: "md",
                                mb: "24px",
                                children: t("Compete with Confidence: Secure, Decentralized, and Fun Contests")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                children: [
                                    !account && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                                        mr: "8px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                                        to: "#metrics",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: !account ? "secondary" : "primary",
                                            children: t("More infos")
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        height: [
                            "192px",
                            null,
                            null,
                            "100%"
                        ],
                        width: [
                            "192px",
                            null,
                            null,
                            "100%"
                        ],
                        flex: [
                            null,
                            null,
                            null,
                            "1"
                        ],
                        mb: [
                            "24px",
                            null,
                            null,
                            "0"
                        ],
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BunnyWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: astronaut_bunny/* default */.Z,
                                    priority: true,
                                    placeholder: "blur",
                                    alt: t("LFG Hero Image")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompositeImage, (0,_object_spread/* default */.Z)({}, starsImage))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Hero = (Hero);

// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(1898);
;// CONCATENATED MODULE: ./src/views/Home/components/GamePresentation/index.tsx

function GamePresentation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 24px;\n  width: 100%;\n  flex-direction: column;\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    GamePresentation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GamePresentation_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-self: baseline;\n  position: relative;\n  background: ",
        ";\n  padding: 1px 1px 3px 1px;\n  border-radius: ",
        ";\n"
    ]);
    GamePresentation_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function GamePresentation_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 24px;\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    GamePresentation_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StepContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e75261f6-0"
})(GamePresentation_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledGameCard = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-e75261f6-1"
})(GamePresentation_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
var GameCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-e75261f6-2"
})(GamePresentation_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
var GameCard = function(param) {
    var step = param.step;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGameCard, {
        width: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GameCardInner, {
            height: [
                "200px",
                "180px",
                null,
                "250px"
            ],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mb: "16px",
                    fontSize: "12px",
                    bold: true,
                    textAlign: "right",
                    textTransform: "uppercase",
                    children: step.label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    mb: "16px",
                    scale: "lg",
                    color: "secondary",
                    children: step.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "textSubtle",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: step.subtitle
                        }
                    })
                })
            ]
        })
    });
};
var GamePresentation = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var steps = [
        {
            label: t("Game type #%number%", {
                number: 1
            }),
            title: t("Classic Giveaway Contests"),
            subtitle: t("Join our classic contest by completing a predefined task (such as liking or retweeting a post) on you favorite Social Media. </br>\n        Winners will be randomly selected from the pool of participants. </br>\n        Prize will be claimable by winner(s) after verification of their Social Media account property.")
        },
        {
            label: t("Game type #%number%", {
                number: 2
            }),
            title: t("Daily Action Game"),
            subtitle: t("Register to the game through to LFG dapp. </br>\n      Play our one-button game once a day during a random time slot. </br>\n      Be one of the last players to share the prize pool.")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mb: "40px",
                alignItems: "center",
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        mb: "24px",
                        scale: "xl",
                        color: "secondary",
                        children: t("Fun and innovative games contests")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        textAlign: "center",
                        children: t("LFG provides a transparent and secure dapp for hosting two types of Social Media contests:")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepContainer, {
                children: steps.map(function(step) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GameCard, {
                        step: step
                    }, step.label);
                })
            })
        ]
    });
};
/* harmony default export */ var components_GamePresentation = (GamePresentation);

;// CONCATENATED MODULE: ./src/views/Home/components/HowToPlay/HowToPlay.tsx

function HowToPlay_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 24px;\n  width: 100%;\n  flex-direction: column;\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    HowToPlay_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HowToPlay_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-self: baseline;\n  position: relative;\n  background: ",
        ";\n  padding: 1px 1px 3px 1px;\n  border-radius: ",
        ";\n"
    ]);
    HowToPlay_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HowToPlay_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 24px;\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    HowToPlay_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var HowToPlay_StepContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a5c45f4f-0"
})(HowToPlay_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledStepCard = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-a5c45f4f-1"
})(HowToPlay_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
var StepCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-a5c45f4f-2"
})(HowToPlay_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
var StepCard = function(param) {
    var step = param.step;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStepCard, {
        width: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepCardInner, {
            height: [
                "200px",
                "180px",
                null,
                "250px"
            ],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    mb: "16px",
                    fontSize: "12px",
                    bold: true,
                    textAlign: "right",
                    textTransform: "uppercase",
                    children: step.label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    mb: "16px",
                    scale: "lg",
                    color: "secondary",
                    children: step.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "textSubtle",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: step.subtitle
                        }
                    })
                })
            ]
        })
    });
};
var HowToPlay = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var steps = [
        {
            label: t("Step %number%", {
                number: 1
            }),
            title: t("Register for a game"),
            subtitle: t("For the daily action game, choose between available games and register to one of them.</br>\n        For the classic contest, just participate on social media platform (creator will have to register the contest on LFG).")
        },
        {
            label: t("Step %number%", {
                number: 2
            }),
            title: t("Perform predefined task"),
            subtitle: t("For the daily action game, play once a day during the random time range.</br>\n        For the classic contest, perform predefined task asked by creator.")
        },
        {
            label: t("Step %number%", {
                number: 3
            }),
            title: t("Game ends"),
            subtitle: t("For the daily action game, try to be one of the last to win the prize.</br>\n        For the classic contest, wait until the required number of players has registered, draw will be automatically triggered.")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mb: "40px",
                alignItems: "center",
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        mb: "24px",
                        scale: "xl",
                        color: "secondary",
                        children: t("How to Play")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        textAlign: "center",
                        children: t("Let’s Fucking Game Rules")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("Simple & Fun!")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowToPlay_StepContainer, {
                children: steps.map(function(step) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepCard, {
                        step: step
                    }, step.label);
                })
            })
        ]
    });
};
/* harmony default export */ var HowToPlay_HowToPlay = (HowToPlay);

// EXTERNAL MODULE: ./packages/uikit/src/components/Image/Image.tsx + 3 modules
var Image = __webpack_require__(73965);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronUp.tsx
var ChevronUp = __webpack_require__(85592);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(3215);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(34899);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Button/ExpandableButton.tsx





var ExpandableButton = function ExpandableButton(param) {
    var onClick = param.onClick, expanded = param.expanded, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
        "aria-label": "Hide or show expandable content",
        onClick: onClick,
        children: [
            children,
            expanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUp/* default */.Z, {
                color: "invertedContrast"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {
                color: "invertedContrast"
            })
        ]
    });
};
ExpandableButton.defaultProps = {
    expanded: false
};
var ExpandableLabel = function ExpandableLabel(param) {
    var onClick = param.onClick, expanded = param.expanded, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        variant: "text",
        "aria-label": "Hide or show expandable content",
        onClick: onClick,
        endIcon: expanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUp/* default */.Z, {
            color: "primary"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {
            color: "primary"
        }),
        children: children
    });
};
ExpandableLabel.defaultProps = {
    expanded: false
};

;// CONCATENATED MODULE: ./src/components/FoldableSection/FoldableText.tsx





function FoldableText_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    FoldableText_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FoldableText_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  button {\n    align-items: center;\n    justify-content: flex-start;\n  }\n"
    ]);
    FoldableText_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FoldableText_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  height: ",
        ";\n  padding-bottom: ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    FoldableText_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var FoldableText_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-8285e73f-0"
})(FoldableText_templateObject());
var StyledExpandableLabelWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-8285e73f-1"
})(FoldableText_templateObject1());
var StyledChildrenFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-8285e73f-2"
})(FoldableText_templateObject2(), function(param) {
    var isExpanded = param.isExpanded;
    return isExpanded ? "100%" : "0px";
}, function(param) {
    var isExpanded = param.isExpanded;
    return isExpanded ? "16px" : "0px";
}, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
});
var FoldableText = function(_param) {
    var title = _param.title, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "children"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), isExpanded = _useState[0], setIsExpanded = _useState[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FoldableText_Wrapper, {
                justifyContent: "space-between",
                alignItems: "center",
                pb: "16px",
                onClick: function() {
                    return setIsExpanded(function(s) {
                        return !s;
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontWeight: "bold",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledExpandableLabelWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableLabel, {
                            expanded: isExpanded,
                            children: isExpanded ? t("Hide") : t("Details")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledChildrenFlex, {
                isExpanded: isExpanded,
                flexDirection: "column",
                children: children
            })
        ]
    }));
};
/* harmony default export */ var FoldableSection_FoldableText = (FoldableText);

;// CONCATENATED MODULE: ./src/views/Home/components/Rules/Rules.tsx

function Rules_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: 1px;\n  margin: 40px 0;\n  width: 100%;\n"
    ]);
    Rules_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Rules_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  margin-left: 8px;\n  padding: 0;\n  li {\n    margin: 0;\n    padding: 0;\n  }\n  li::before {\n    content: '•';\n    margin-right: 4px;\n    color: ",
        ";\n  }\n  li::marker {\n    font-size: 12px;\n  }\n"
    ]);
    Rules_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Rules_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-self: baseline;\n  position: relative;\n  background: ",
        ";\n  padding: 1px 1px 3px 1px;\n  border-radius: ",
        ";\n"
    ]);
    Rules_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Rules_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 24px;\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    Rules_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Rules_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 4fr 1fr;\n  grid-auto-rows: max-content;\n  row-gap: 4px;\n"
    ]);
    Rules_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Rules_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  margin-right: 8px;\n  background-color: ",
        ";\n"
    ]);
    Rules_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 24px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-99b9de1b-0"
})(Rules_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var BulletList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-99b9de1b-1"
})(Rules_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var Rules_StyledStepCard = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-99b9de1b-2"
})(Rules_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
var Rules_StepCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-99b9de1b-3"
})(Rules_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
var WinningCriteriaDrawing = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/images/Saly-6.png",
        alt: "drawing of winning criteria",
        width: 212,
        height: 212
    });
};
var RulesDrawing = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/images/Saly-23.png",
        alt: "drawing of prize rules",
        width: 118,
        height: 118
    });
};
var AllocationGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-99b9de1b-4"
})(Rules_templateObject4());
var AllocationColorCircle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-99b9de1b-5"
})(Rules_templateObject5(), function(param) {
    var color = param.color;
    return color;
});
var AllocationMatch = function(param) {
    var color = param.color, text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AllocationColorCircle, {
                color: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                children: text
            })
        ]
    });
};
var PoolAllocations = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Rules_StyledStepCard, {
        width: [
            "280px",
            "330px",
            "380px"
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Rules_StepCardInner, {
            height: "auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    mb: "8px",
                    justifyContent: "center",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RulesDrawing, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "12px",
                            pb: "16px",
                            color: "secondary",
                            bold: true,
                            textTransform: "uppercase",
                            children: t("Player bank")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "12px",
                            pb: "16px",
                            color: "secondary",
                            bold: true,
                            textAlign: "right",
                            textTransform: "uppercase",
                            children: t("Prize pool allocation")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AllocationGrid, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AllocationMatch, {
                            color: "#FFE362",
                            text: t("First player")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            pb: "8px",
                            textAlign: "right",
                            bold: true,
                            children: "80%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AllocationMatch, {
                            color: "#85C54E",
                            text: t("Second player")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            pb: "8px",
                            textAlign: "right",
                            bold: true,
                            children: "10%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AllocationMatch, {
                            color: "#028E75",
                            text: t("Third player")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            pb: "8px",
                            textAlign: "right",
                            bold: true,
                            children: "5%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AllocationMatch, {
                            color: "#BDC2C4",
                            text: t("Bank")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            pb: "8px",
                            textAlign: "right",
                            bold: true,
                            children: "10%"
                        })
                    ]
                })
            ]
        })
    });
};
var GappedFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-99b9de1b-6"
})(_templateObject6());
var Rules = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mb: "40px",
                alignItems: "center",
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        mb: "24px",
                        scale: "xl",
                        color: "secondary",
                        children: t("Rules")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        textAlign: "center",
                        children: t("LFG games rules")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GappedFlex, {
                flexDirection: [
                    "column",
                    "column",
                    "column",
                    "row"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flex: "2",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                mb: "24px",
                                scale: "lg",
                                color: "secondary",
                                children: t("Games Rules")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FoldableSection_FoldableText, {
                                title: t("Classic Giveaway Contest"),
                                mb: "24px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mb: "16px",
                                        color: "textSubtle",
                                        children: t("Contest creators first create a tweet and then use LFG to create the contest, entering the contest rules.")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mb: "16px",
                                        color: "textSubtle",
                                        children: t("Participants can join the contest as they traditionally do on social media platforms. For example, if the contest is on Twitter and requires participants to retweet a tweet, they should do so.")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mb: "24px",
                                        color: "textSubtle",
                                        children: t("The winner(s) are determined automatically by the smart contract, and the prize will be claimable after verification with their Twitter account using the Twitter API.")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FoldableSection_FoldableText, {
                                title: t("Daily Action Game"),
                                mb: "24px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mb: "16px",
                                        color: "textSubtle",
                                        children: t("Players interact with the game's smart contract once per day during a randomly selected time slot.")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mb: "16px",
                                        color: "textSubtle",
                                        children: t("The last remaining players share the prizes according to the prize pool's distribution.")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mb: "16px",
                                        color: "textSubtle",
                                        children: t("When the number of players drops to below 50%, one player can vote to split the pot between the remaining players. If all remaining players agree to split the pot, the pot is fairly distributed between them.")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mb: "24px",
                                        color: "textSubtle",
                                        children: t("During the game configuration, the creator have the ability to choose the time slots as well as the winners' structure to allow for more or fewer players to win more or less of the prize pool.")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FoldableSection_FoldableText, {
                                title: t("Split Prizepool"),
                                mb: "24px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mb: "16px",
                                        color: "textSubtle",
                                        children: t("Players can also vote to split pot when there are less than 50% of remaining players.")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mb: "16px",
                                        color: "textSubtle",
                                        children: t(" This could be useful if the game takes too long. If all players vote to split, the smart contract will stop the game and split prizepool to remaining players.")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        flex: "1",
                        justifyContent: "center",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WinningCriteriaDrawing, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GappedFlex, {
                flexDirection: [
                    "column",
                    "column",
                    "column",
                    "row"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flex: "2",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                mb: "24px",
                                scale: "lg",
                                color: "secondary",
                                children: t("PrizePool")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                mb: "8px",
                                children: t("Here are the default game prize allocation.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                mb: "24px",
                                children: t("Game creators can update those parameters so check data for each game before register.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FoldableSection_FoldableText, {
                                title: t("Classic Giveaway Contest"),
                                mb: "24px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    mb: "16px",
                                    color: "textSubtle",
                                    children: t("The prizepool came from game creator only. He will set the prize pool during game creation.")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FoldableSection_FoldableText, {
                                title: t("Daily Action Game"),
                                mb: "24px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mb: "18px",
                                        color: "textSubtle",
                                        children: t("The prizes for each game can come from two sources:")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "18px",
                                        bold: true,
                                        ml: "16px",
                                        children: t("Player registration")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletList, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                display: "inline",
                                                color: "textSubtle",
                                                children: t("Registration amount paid by people goes back into the prize pools, minus creator and treasury fees.")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "18px",
                                        bold: true,
                                        ml: "16px",
                                        mt: "16px",
                                        children: t("Creator Prizes")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletList, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                display: "inline",
                                                color: "textSubtle",
                                                children: t("Creator can create a game and set the prize pool during game creation.")
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        flex: "1",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolAllocations, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {})
        ]
    });
};
/* harmony default export */ var Rules_Rules = (Rules);

// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(85719);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(20000);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(94244);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/CardHeader.tsx

function CardHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  ",
        "\n"
    ]);
    CardHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e97edbbd-0"
}).withConfig({
    componentId: "sc-cc72fb85-0"
})(CardHeader_templateObject(), function(param) {
    var theme = param.theme, _param_variant = param.variant, variant = _param_variant === void 0 ? "default" : _param_variant;
    return theme.card.cardHeaderBackground[variant];
}, function(param) {
    var theme = param.theme;
    return "".concat(theme.radii.card, " ").concat(theme.radii.card, " 0 0");
}, index_esm/* space */.Dh);
CardHeader.defaultProps = {
    p: "24px"
};
/* harmony default export */ var Card_CardHeader = (CardHeader);

;// CONCATENATED MODULE: ./src/views/Home/components/FAQ/FAQ.tsx

function FAQ_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin: auto;\n  padding: 0 24px 72px 24px;\n  flex-direction: column-reverse;\n  align-items: center;\n\n  ",
        " {\n    flex-direction: row;\n    max-width: 1140px;\n  }\n"
    ]);
    FAQ_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FAQ_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  div:first-child {\n    margin-top: 0px;\n  }\n"
    ]);
    FAQ_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FAQ_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  margin: 0 4px;\n"
    ]);
    FAQ_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var MustachioedMan = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/images/Saly-11.png",
        alt: "drawing of a mustachioed man",
        width: 367,
        height: 367
    });
};
var FAQ_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6bd57b4d-0"
})(FAQ_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
});
var StyledCardbody = (0,styled_components_browser_esm/* default */.ZP)(CardBody/* default */.Z).withConfig({
    componentId: "sc-6bd57b4d-1"
})(FAQ_templateObject1());
var InlineLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-6bd57b4d-2"
})(FAQ_templateObject2());
var FAQ = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FAQ_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MustachioedMan, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardHeader, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            color: "secondary",
                            scale: "lg",
                            children: t("FAQ")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardbody, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FoldableSection_FoldableText, {
                                title: t("What types of prizes can be won on LFGames ?"),
                                mt: "24px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    color: "textSubtle",
                                    children: t("Our platform supports the ability to offer a variety of different prizes, including ERC20 tokens and ERC721 tokens for NFTs.")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FoldableSection_FoldableText, {
                                title: t("How can I be sure to receive the prize if I win the contest ?"),
                                mt: "24px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    color: "textSubtle",
                                    children: [
                                        t("Thanks to blockchain and smart contracts, prizes are uploaded before the game starts, ensuring that they are available and transparently managed."),
                                        t("All our Smart Contract are public and verified. You can check all deployed smart contract source code on our GitHub repository.")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FoldableSection_FoldableText, {
                                title: t("How is the time range for the daily action game calculated for Daily Action Game ?"),
                                mt: "24px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    color: "textSubtle",
                                    children: t("The time range is randomly generated by our smart contract, and is managed by the game creator. It can vary between 2 hours and 8 hours a day. Each day, the time slot for each player is randomly selected by our smart contract, at a predefined time selected by the contest creator.")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FoldableSection_FoldableText, {
                                title: t("How long does a game typically last ?"),
                                mt: "24px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mt: "16px",
                                        bold: true,
                                        children: t("Classic Giveaway Contest")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        color: "textSubtle",
                                        children: t("The winners will be randomly selected when the maximum number of players is met. The length of the game can vary depending on the size and engagement of the community, but it can take a few minutes to a few days.")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mt: "16px",
                                        bold: true,
                                        children: t("Daily Action Game")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        color: "textSubtle",
                                        children: t("The length of a game can vary depending on the number of players and other factors. During our tests, games with 10 players and 2 prizes lasted between 2 and 5 days.")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FoldableSection_FoldableText, {
                                title: t("Can I stop playing a game if I don't want to continue ?"),
                                mt: "24px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    color: "textSubtle",
                                    children: t("The time range is randomly generated by our smart contract, and is managed by the game creator. It can vary between 2 hours and 8 hours a day. Each day, the time slot for each player is randomly selected by our smart contract, at a predefined time selected by the contest creator.")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FoldableSection_FoldableText, {
                                title: t("How long does a game typically last ?"),
                                mt: "24px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mt: "16px",
                                        bold: true,
                                        children: t("Classic Giveaway Contest")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        color: "textSubtle",
                                        children: t("Once your participation is validated, you cannot remove it. However, if you win and do not want to claim your prize, you can choose not to do so.")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mt: "16px",
                                        bold: true,
                                        children: t("Daily Action Game")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        color: "textSubtle",
                                        children: t("Yes, you can stop playing a game at any time, but you will lose the game.")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FoldableSection_FoldableText, {
                                title: t("When will the contests be launched in production ?"),
                                mt: "24px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    color: "textSubtle",
                                    children: t("We want to ensure that our smart contracts are secure before launching the contests in production. We hope to win a hackathon or find a community that can help us make it a reality. If you are interested in partnering with us or contributing to the project, please contact us on Twitter.")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FoldableSection_FoldableText, {
                                title: t(" What is the fee structure for creating a contest on LFGames ?"),
                                mt: "24px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    color: "textSubtle",
                                    children: t("The fee structure for creating a contest on LFGames varies depending on the type of contest and the amount of prize money being offered. Our platform charges a small percentage fee to creators for hosting their contests on the platform.")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FoldableSection_FoldableText, {
                                title: t("Can i contact you for partnership ?"),
                                mt: "24px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    children: [
                                        t("For sur! Please feel free to reach out to us on"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineLink, {
                                            fontSize: "14px",
                                            external: true,
                                            href: "https://twitter.com/0xGeegZ",
                                            children: t("Twitter")
                                        }),
                                        t("or"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineLink, {
                                            fontSize: "14px",
                                            external: true,
                                            href: "https://www.linkedin.com/in/guillaumedieudonne/",
                                            children: t("LinkedIn")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FAQ_FAQ = (FAQ);

;// CONCATENATED MODULE: ./src/views/Home/components/CheckPrizesSection/CheckPrizesSection.tsx

function CheckPrizesSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 80px;\n  ",
        " {\n    height: 120px;\n  }\n"
    ]);
    CheckPrizesSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CheckPrizesSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 70px;\n  ",
        " {\n    height: 80px;\n  }\n"
    ]);
    CheckPrizesSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var MoneyImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-65ccb3a0-0"
})(CheckPrizesSection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var DiamondImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-65ccb3a0-1"
})(CheckPrizesSection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var CheckPrizesSection = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var getBody = function() {
        if (!account) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MoneyImage, {
                        src: "/images/Saly-45.png",
                        alt: "money drawing"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mx: [
                            "4px",
                            null,
                            "16px"
                        ],
                        flexDirection: "column",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                textAlign: "center",
                                color: "#F4EEFF",
                                children: t("Connect your wallet")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                textAlign: "center",
                                color: "#F4EEFF",
                                mb: "24px",
                                children: t("to start a new game")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                                width: "190px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DiamondImage, {
                        src: "/images/Saly-28.png",
                        alt: "diamond drawing"
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            alignItems: "center",
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MoneyImage, {
                    src: "/images/Saly-45.png",
                    alt: "money drawing"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    mx: [
                        "4px",
                        null,
                        "16px"
                    ],
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            textAlign: "center",
                            color: "#F4EEFF",
                            children: t("Connect your wallet")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            textAlign: "center",
                            color: "#F4EEFF",
                            mb: "24px",
                            children: t("to start a new game")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                            width: "190px"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DiamondImage, {
                    src: "/images/Saly-28.png",
                    alt: "diamond drawing"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        children: getBody()
    });
};
/* harmony default export */ var CheckPrizesSection_CheckPrizesSection = (CheckPrizesSection);

// EXTERNAL MODULE: ./src/views/Games/index.tsx + 12 modules
var Games = __webpack_require__(43474);
// EXTERNAL MODULE: ./src/views/Games/components/GameCard/index.tsx + 38 modules
var components_GameCard = __webpack_require__(8263);
// EXTERNAL MODULE: ./src/utils/sortGames.ts
var sortGames = __webpack_require__(15458);
// EXTERNAL MODULE: ./src/state/games/hooks.ts + 3 modules
var hooks = __webpack_require__(98823);
// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(21270);
// EXTERNAL MODULE: ./src/components/Layout/Flex.tsx
var Layout_Flex = __webpack_require__(67552);
;// CONCATENATED MODULE: ./src/views/Home/components/Games/index.tsx












var NUMBER_OF_GAMES_VISIBLE = 3;
var GamesPage = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var _useGames = (0,hooks/* useGames */.ek)(), games = _useGames.data;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(NUMBER_OF_GAMES_VISIBLE), 1), numberOfGamesVisible = _useState[0];
    var activeGames = games.filter(function(game) {
        return !game.isDeleted && !game.isPaused && !game.isInProgress;
    });
    if (activeGames.length < NUMBER_OF_GAMES_VISIBLE) activeGames = games.filter(function(game) {
        return !game.isDeleted && !game.isPaused;
    });
    var chosenGamesMemoized = (0,react.useMemo)(function() {
        return activeGames.sort(sortGames/* sortGamesLaunching */.h).slice(0, numberOfGamesVisible);
    }, [
        activeGames,
        numberOfGamesVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mb: "40px",
                alignItems: "center",
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        mb: "24px",
                        scale: "xl",
                        color: "secondary",
                        children: t("Choose your Game")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        textAlign: "center",
                        children: t("Register for the game and wait until the total number of players is reached")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Flex/* default */.Z, {
                children: [
                    chosenGamesMemoized.map(function(game) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GameCard/* default */.Z, {
                            game: game,
                            account: account
                        }, game.id.toNumber());
                    }),
                    !chosenGamesMemoized.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};
GamesPage.Layout = Games/* GamesPageLayout */.P;
/* harmony default export */ var components_Games = (GamesPage);

;// CONCATENATED MODULE: ./src/views/Home/pageSectionStyles.tsx
var HERO_TOP_BG = "linear-gradient(139.73deg, #E6FDFF 0%, #F3EFFF 100%)";
var HERO_BOTTOM_BG = "linear-gradient(180deg, #FFFFFF 22%, #D7CAEC 100%)";
var HERO_SVG_TOP = "linear-gradient(180deg, rgba(255, 255, 255, 0.48) 24.67%, rgba(255, 255, 255, 0.35) 67.34%, #FFFFFF 100%);";
var HERO_SVG_BOTTOM = "#D8CBED";
var CHECK_PRIZES_BG = "linear-gradient(139.73deg, #313D5C 0%, #3D2A54 100%)";

;// CONCATENATED MODULE: ./src/views/Home/components/Why/Why.tsx

function Why_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 24px;\n"
    ]);
    Why_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Why_GappedFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-234e0348-0"
})(Why_templateObject());
var Why = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mb: "24px",
                alignItems: "center",
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        mb: "24px",
                        scale: "xl",
                        color: "secondary",
                        children: t("About Us")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("We are a team of passionate developers who are excited about the potential of blockchain technology and its ability to transform the way we interact with the world. Our mission is to create a more transparent and secure platform for hosting online contests and bring a new way to activate communities.")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Why_GappedFlex, {
                flexDirection: [
                    "column",
                    "column",
                    "column",
                    "row"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flex: "2",
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            mt: "24px",
                            scale: "md",
                            children: t("To Have Fun")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            mb: "16px",
                            color: "textSubtle",
                            children: t("We created this project because we love to have fun while exploring new technologies. LFG is a project that allows us to experiment with the latest advancements in web3 while providing a fun and engaging experience for our users.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            mt: "24px",
                            scale: "md",
                            children: t("To Discover Web3")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            mb: "16px",
                            color: "textSubtle",
                            children: t("As a team of developers, we are always looking for ways to push the boundaries of what's possible with technology. With LFG, we have the opportunity to learn about new concepts like keepers and EPNS and explore the full potential of the blockchain.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            mt: "24px",
                            scale: "md",
                            children: t("To Bring a New Way to Engage Communities")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            mb: "16px",
                            color: "textSubtle",
                            children: t("We believe that online contests are a great way to engage with your community, but we also recognize that there are a lot of scams and fake contests out there. With LFG, we aim to provide a secure and transparent platform that allows creators to easily activate their community through fun and engaging games.")
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Why_Why = (Why);

;// CONCATENATED MODULE: ./src/views/Home/Home.tsx

function Home_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n\n  ",
        " {\n    padding-top: 48px;\n  }\n"
    ]);
    Home_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Home_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n"
    ]);
    Home_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var StyledHeroSection = (0,styled_components_browser_esm/* default */.ZP)(components_PageSection).withConfig({
    componentId: "sc-87cd5438-0"
})(Home_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledGameSection = (0,styled_components_browser_esm/* default */.ZP)(components_PageSection).withConfig({
    componentId: "sc-87cd5438-1"
})(Home_templateObject1());
var Home = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageMeta */.V, {}),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "974dd047180e6131",
                children: '#hero .page-bg{background:-webkit-linear-gradient(310.27deg,#e6fdff 0%,#f3efff 100%);background:-moz-linear-gradient(310.27deg,#e6fdff 0%,#f3efff 100%);background:-o-linear-gradient(310.27deg,#e6fdff 0%,#f3efff 100%);background:linear-gradient(139.73deg,#e6fdff 0%,#f3efff 100%)}[data-theme="dark"] #hero .page-bg{background:-webkit-radial-gradient(50%50%,103.12%50%,#21193a 0%,#191326 100%);background:-moz-radial-gradient(50%50%,103.12%50%,#21193a 0%,#191326 100%);background:-o-radial-gradient(50%50%,103.12%50%,#21193a 0%,#191326 100%);background:radial-gradient(103.12%50%at 50%50%,#21193a 0%,#191326 100%)}#metrics .page-bg{background:-webkit-linear-gradient(top,#fff 22%,#d7caec 100%);background:-moz-linear-gradient(top,#fff 22%,#d7caec 100%);background:-o-linear-gradient(top,#fff 22%,#d7caec 100%);background:linear-gradient(180deg,#fff 22%,#d7caec 100%)}[data-theme="dark"] #metrics .page-bg{background:-webkit-linear-gradient(top,#09070c 22%,#201335 100%);background:-moz-linear-gradient(top,#09070c 22%,#201335 100%);background:-o-linear-gradient(top,#09070c 22%,#201335 100%);background:linear-gradient(180deg,#09070c 22%,#201335 100%)}#home-3 .page-bg{background:-webkit-linear-gradient(top,#6fb6f1 0%,#eaf2f6 100%);background:-moz-linear-gradient(top,#6fb6f1 0%,#eaf2f6 100%);background:-o-linear-gradient(top,#6fb6f1 0%,#eaf2f6 100%);background:linear-gradient(180deg,#6fb6f1 0%,#eaf2f6 100%)}[data-theme="dark"] #home-3 .page-bg{background:-webkit-linear-gradient(top,#0b4576 0%,#091115 100%);background:-moz-linear-gradient(top,#0b4576 0%,#091115 100%);background:-o-linear-gradient(top,#0b4576 0%,#091115 100%);background:linear-gradient(180deg,#0b4576 0%,#091115 100%)}#why .inner-wedge svg{fill:#d8cbed}[data-theme="dark"] #why .inner-wedge svg{fill:#201335}'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroSection, {
                innerProps: {
                    style: {
                        margin: "0",
                        width: "100%"
                    }
                },
                containerProps: {
                    id: "hero"
                },
                index: 2,
                hasCurvedDivider: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Hero, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageSection, {
                innerProps: {
                    style: {
                        margin: "0",
                        width: "100%"
                    }
                },
                containerProps: {
                    id: "metrics"
                },
                index: 2,
                hasCurvedDivider: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GamePresentation, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageSection, {
                index: 2,
                dividerPosition: "top",
                containerProps: {
                    id: "how-to-play"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HowToPlay_HowToPlay, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGameSection, {
                innerProps: {
                    style: {
                        padding: "24px 0 0",
                        width: "100%"
                    }
                },
                index: 2,
                hasCurvedDivider: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Games, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_PageSection, {
                index: 2,
                dividerPosition: "bottom",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rules_Rules, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ_FAQ, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageSection, {
                background: CHECK_PRIZES_BG,
                hasCurvedDivider: false,
                index: 2,
                containerProps: {
                    id: "prizes"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckPrizesSection_CheckPrizesSection, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageSection, {
                innerProps: {
                    style: {
                        margin: "0",
                        width: "100%"
                    }
                },
                containerProps: {
                    id: "why"
                },
                index: 2,
                hasCurvedDivider: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Why_Why, {})
            })
        ]
    });
};
/* harmony default export */ var Home_Home = (Home);

;// CONCATENATED MODULE: ./src/views/Home/index.tsx

/* harmony default export */ var views_Home = (Home_Home);

;// CONCATENATED MODULE: ./src/pages/index.tsx



var IndexPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SWRConfig */.J$, {
        value: {
            fallback: {}
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(views_Home, {})
    });
};
IndexPage.chains = [];
/* harmony default export */ var pages = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [225,855,755,332,375,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);